import { Post, User } from "../../types";
import { t } from "../i18n/strings";

export const DEMO_EMAIL = "demo@local.test";
export const DEMO_PASSWORD = "123456";

export const demoUser: User = {
  uid: "local-demo-user",
  email: DEMO_EMAIL,
  displayName: t("demoUserName"),
  photoURL: "",
  followingCount: 0,
  followersCount: 0,
  likesCount: 0,
};

export const demoPosts: Post[] = [
  {
    id: "local-demo-post-1",
    creator: demoUser.uid,
    media: [
      "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=80",
    ],
    description: "Local demo video. Replace Firebase config to use real posts.",
    likesCount: 12,
    commentsCount: 0,
    creation: new Date().toISOString(),
  },
];
